import { render, staticRenderFns } from "./PublicProjectApartmentModels.vue?vue&type=template&id=1c959548&"
import script from "./PublicProjectApartmentModels.vue?vue&type=script&lang=js&"
export * from "./PublicProjectApartmentModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports